export default {
    props: {
        dataName: {
            type: String,
            required: true
        },

        dataHeading: {
            type: String,
            required: true
        },

        dataTooltip: {
            type: String,
            required: false
        }
    },

    computed: {
        name() {
            return this.dataName;
        },

        heading() {
            return this.dataHeading;
        },

        tooltip() {
            return this.dataTooltip;
        }
    }
};
